import React from 'react';
import PropTypes from 'prop-types';
import {
  GoPaperlessPolicyPreferenceContainer,
  PolicyEmailAddress,
  PolicyLabelMobile,
  PolicyMailingAddress,
  PolicyNumberLabel,
  PolicySummary,
  PreferenceLabelMobile,
  PreferenceRadioEmail,
  PreferenceRadioMail,
  ProfileEditorsContainer,
  ProfileRadioButtonContainer,
  StatementPreferenceInfo,
} from './styles';
import { getText } from '../../../utils/i18n';
import { getStatementAddress, getStatementEmailAddress } from './selectors';

export const StatementAccountAndUnderlyingPoliciesDeliveryPreferences = (props) => {
  const {
    editingDeliveryPreferences,
    filteredStatementAccounts,
    i18n,
    isLoading,
    setStatementAccountDeliveryPreference,
    statementAccountDeliveryPreference,
    statementAccounts,
  } = props;

  const goPaperlessMissingEmailHelperText = getText(
    i18n,
    'policyDetails.helper.missingEmailText',
    'No email address found. Please add an email address to your policy if you wish to select paperless.',
  );

  return (
    <>
      {statementAccountDeliveryPreference.length > 0 &&
        statementAccounts.map((policy, index) => {
          let currentStatementAccountPolicy = filteredStatementAccounts.find(
            (account) =>
              account.fullAccount.accountDisplayNumber === policy.statementAccountDisplayNumber,
          );
          let underlyingSAPolicyNames =
            currentStatementAccountPolicy.fullAccount.underlyingBillingAccounts.reduce(
              (acc, account) =>
                account.accountDisplayName !== 'Statement'
                  ? `${account.arPolicy?.policyNumber} (${account?.arPolicy?.statusCd})${
                      acc ? ',' : ''
                    } ${acc}`
                  : acc,
              '',
            );

          return (
            <GoPaperlessPolicyPreferenceContainer key={index} $index={index}>
              <PolicySummary>
                <PolicyLabelMobile>{underlyingSAPolicyNames}</PolicyLabelMobile>
                <PolicyNumberLabel>{underlyingSAPolicyNames}</PolicyNumberLabel>
                <PolicyEmailAddress>
                  Email:{' '}
                  {getStatementEmailAddress(currentStatementAccountPolicy)
                    ? getStatementEmailAddress(currentStatementAccountPolicy)
                    : goPaperlessMissingEmailHelperText}
                </PolicyEmailAddress>
                <StatementPreferenceInfo>
                  Statement Accounts preferences will be applied to all underlying policies <br />
                </StatementPreferenceInfo>
                <PolicyMailingAddress>
                  Address: {getStatementAddress(currentStatementAccountPolicy)}
                </PolicyMailingAddress>
              </PolicySummary>
              <ProfileEditorsContainer>
                <PreferenceLabelMobile>Preference</PreferenceLabelMobile>
                <ProfileRadioButtonContainer>
                  <PreferenceRadioEmail>
                    <label htmlFor={`radioEmailStatement${index}`}>
                      <input
                        aria-label={`Preference for statement account communications via email`}
                        type="radio"
                        name={`deliveryPref_statements_${index}`}
                        value="Email"
                        id={`radioEmailStatement${index}`}
                        onChange={(e) =>
                          setStatementAccountDeliveryPreference((previousDeliveryPrefs) => {
                            return previousDeliveryPrefs.map((item) => {
                              return item.systemId === policy.statementFeeAccountRef
                                ? { ...item, deliveryPreference: e.target.value }
                                : item;
                            });
                          })
                        }
                        checked={
                          statementAccountDeliveryPreference.find((preference) => {
                            return policy.statementFeeAccountRef === preference.systemId;
                          })?.deliveryPreference === 'Email'
                        }
                        disabled={
                          isLoading ||
                          !editingDeliveryPreferences ||
                          !getStatementEmailAddress(currentStatementAccountPolicy)
                        }
                      />{' '}
                      Paperless
                    </label>
                  </PreferenceRadioEmail>
                  <PreferenceRadioMail>
                    <label htmlFor={`radioBatchStatement${index}`}>
                      <input
                        aria-label={`Preference for statement account communications via Mail`}
                        type="radio"
                        name={`deliveryPref_statements_${index}`}
                        value="Batch"
                        id={`radioBatchStatement${index}`}
                        onChange={(e) =>
                          setStatementAccountDeliveryPreference((previousDeliveryPrefs) => {
                            return previousDeliveryPrefs.map((item) => {
                              return item.systemId === policy.statementFeeAccountRef
                                ? { ...item, deliveryPreference: e.target.value }
                                : item;
                            });
                          })
                        }
                        checked={
                          statementAccountDeliveryPreference.find((preference) => {
                            return policy.statementFeeAccountRef === preference.systemId;
                          })?.deliveryPreference === 'Batch'
                        }
                        disabled={isLoading || !editingDeliveryPreferences}
                      />{' '}
                      Mail
                    </label>
                  </PreferenceRadioMail>
                </ProfileRadioButtonContainer>
              </ProfileEditorsContainer>
            </GoPaperlessPolicyPreferenceContainer>
          );
        })}
    </>
  );
};

StatementAccountAndUnderlyingPoliciesDeliveryPreferences.propTypes = {
  editingDeliveryPreferences: PropTypes.bool,
  filteredStatementAccounts: PropTypes.array,
  i18n: PropTypes.object,
  isLoading: PropTypes.bool,
  setStatementAccountDeliveryPreference: PropTypes.func,
  statementAccountDeliveryPreference: PropTypes.array,
  statementAccounts: PropTypes.array,
};

export default StatementAccountAndUnderlyingPoliciesDeliveryPreferences;
